import { z } from "@/zod";
import { birthDate, phoneNumber, pesel, ulid } from "@/schemas/commonFields";

export const contractorStudent = z.object({
  id: ulid,
  user_ref_number: z.number(),
  full_name: z.string(),
  personal_id_number: pesel,
  birth_date: birthDate,
  days_until_26_birthday: z.number(),
  tax_status: z.string().optional(),
  agreement_ref_number: z.number(),
  agreement_start_date: birthDate,
  agreement_end_date: birthDate,
  agreement_type_name: z.string(),
  email: z.string().email(),
  phone_number: phoneNumber,
});

export const readContractorStudent = contractorStudent.readonly();
